import useFetch, { UseFetchResult } from "../../../hooks/fetch/useFetch";
import { IPaginationQuery } from "../../../hooks/usePagination";
import { Pagination } from "../../../models/Pagination";
import { EntityType } from "../models/enums/EntityType";
import {
  SettingDefinition,
  SettingDefinitionProps,
} from "../models/SettingDefinition";

interface IUseSettingDefinitions {
  params?: {
    search?: string;
    entity_type?: EntityType;
  } & IPaginationQuery;
}

interface IUseSettingDefinitionsReturn {
  fetch: UseFetchResult<SettingDefinition[]>;
  pagination: Pagination;
}

export const useSettingDefinitions = ({
  params,
}: IUseSettingDefinitions = {}): IUseSettingDefinitionsReturn => {
  const { page = 1, search = "", per_page = 10, ...rest } = params || {};

  const rawFetch = useFetch<SettingDefinitionProps[]>(
    "/api/setting-definitions",
    {
      initialData: [],
      params: {
        page,
        search,
        per_page,
        ...rest,
      },
    }
  );

  const fetch: UseFetchResult<SettingDefinition[]> = {
    ...rawFetch,
    data: (rawFetch.data ?? []).map((d) => new SettingDefinition(d)),
  };

  const pagination = new Pagination(rawFetch.meta);

  return {
    fetch,
    pagination,
  };
};
